var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M0 0h43v43H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#date_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-665-1266H775V861H-665z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.972 11.383a.92.92 0 0 0-.91.936v.916h-.915a2.781 2.781 0 0 0-2.764 2.762v.915h20.235v-.915a2.78 2.78 0 0 0-2.762-2.762h-.916v-.916a.92.92 0 0 0-.938-.937.92.92 0 0 0-.903.937v.916h-3.678v-.916a.92.92 0 0 0-.93-.937.92.92 0 0 0-.911.937v.916h-3.678v-.916a.92.92 0 0 0-.93-.937Zm-4.59 7.367v10.107a2.78 2.78 0 0 0 2.765 2.76h14.709a2.778 2.778 0 0 0 2.762-2.76V18.75H11.383Z",
    fill: "#58B847"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.996 21.645h2.168v2.168h-2.168zM20.416 21.645h2.168v2.168h-2.168zM25.836 21.645h2.168v2.168h-2.168zM14.996 25.981h2.168v2.168h-2.168zM20.416 25.981h2.168v2.168h-2.168zM25.836 25.981h2.168v2.168h-2.168z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "date_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-665 -1266)",
    d: "M0 0h1440v2127H0z"
  })))));
};
export default SvgDate;